import { useRef, useState, useEffect, useCallback } from 'react'
import _ from 'lodash'
// see https://www.benmvp.com/blog/create-react-controlled-components-pattern-custom-hook/
const useControlled = ({ controlledValue, initialValue, name }) => {
  const isControlled = controlledValue !== undefined
  const { current: origIsControlled } = useRef(isControlled)
  const [internalValue, setInternalValue] = useState(initialValue)
  const { current: origInitialValue } = useRef(initialValue)
  const value = origIsControlled ? controlledValue : internalValue

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (origIsControlled !== isControlled) {
        console.warn(
          `"${name}" is changed from ${
            origIsControlled
              ? 'uncontrolled to controlled'
              : 'controlled to uncontrolled'
          }.`
        )
      }
    }
  }, [origIsControlled, isControlled, name])

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      if (!origIsControlled && !_.isEqual(origInitialValue, initialValue)) {
        console.warn(
          `"${name}" is changing its defaultValue after being initialized. Make "${name}" a controlled component instead.`
        )
      }
    }
  }, [origInitialValue, initialValue, name, origIsControlled])

  const setValueIfUncontrolled = useCallback(
    (newValue) => {
      if (!origIsControlled) {
        setInternalValue(newValue)
      }
    },
    [origIsControlled]
  )

  return [value, setValueIfUncontrolled]
}

export default useControlled